(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"]) return;
  try {
    
  (() => {
    const bar = document.querySelector('[data-rotation-ms][data-block-count]');
    if (!bar) return;
    const count = Number(bar.dataset.blockCount) || 0;
    if (count < 2) return;
    const interval = Math.max(3000, Number(bar.dataset.rotationMs) || 5000);
    const items = Array.from(bar.querySelectorAll('.announcement__message'));
    let idx = 0;
    let timerId = null;
    const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function show(n) {
      items.forEach((el, i) => {
        const on = i === n;
        el.classList.toggle('is-active', on);
        if (on) el.removeAttribute('hidden'); else el.setAttribute('hidden', '');
      });
    }
    function start() {
      if (reduce) return;
      stop();
      timerId = window.setInterval(() => {
        idx = (idx + 1) % items.length;
        show(idx);
      }, interval);
    }
    function stop() {
      if (timerId !== null) { window.clearInterval(timerId); timerId = null; }
    }

    bar.addEventListener('mouseenter', stop);
    bar.addEventListener('mouseleave', start);
    bar.addEventListener('focusin', stop);
    bar.addEventListener('focusout', start);

    start();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart-drawer"]) return;
  try {
    
  class CartDrawer extends HTMLElement {
    connectedCallback() {
      this.dialog = this.querySelector('dialog.cart-drawer');
      if (!this.dialog) return;
      this.wireInner();
      this.dialog.addEventListener('click', (e) => { if (e.target === this.dialog) this.close(); });
    }

    static fetchCart() {
      return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
        .then(r => r.ok ? r.json() : null);
    }

    static updateBadge(cart) {
      if (!cart) return;
      document.querySelectorAll('[data-cart-count]').forEach(el => { el.textContent = cart.item_count; });
      document.querySelectorAll('[data-cart-count-inline]').forEach(el => { el.textContent = cart.item_count + ' items'; });
    }

    open() {
      if (!this.dialog) return;
      if (typeof this.dialog.showModal === 'function') this.dialog.showModal();
      else this.dialog.setAttribute('open', '');
      document.querySelectorAll('[data-cart-drawer-open]').forEach(b => b.setAttribute('aria-expanded', 'true'));
    }

    close() {
      if (!this.dialog) return;
      if (typeof this.dialog.close === 'function') this.dialog.close();
      else this.dialog.removeAttribute('open');
      document.querySelectorAll('[data-cart-drawer-open]').forEach(b => b.setAttribute('aria-expanded', 'false'));
    }

    async render() {
      const res = await fetch('/?section_id=cart-drawer', { headers: { 'Accept': 'text/html' } });
      if (!res.ok) return;
      const text = await res.text();
      const parsed = new DOMParser().parseFromString(text, 'text/html');
      const next = parsed.querySelector('cart-drawer#cart-drawer') || parsed.getElementById('cart-drawer');
      if (!next) return;
      const nextDialog = next.querySelector('dialog.cart-drawer');
      if (!nextDialog || !this.dialog) return;
      const nodes = Array.from(nextDialog.childNodes).map(n => n.cloneNode(true));
      this.dialog.replaceChildren(...nodes);
      this.wireInner();
    }

    async update(key, qty) {
      const res = await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: key, quantity: qty })
      });
      if (res.ok) {
        const cart = await res.json();
        CartDrawer.updateBadge(cart);
        await this.render();
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: cart }));
      }
    }

    async add(variantId, quantity) {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: quantity || 1 })
      });
      if (!res.ok) return null;
      const added = await res.json();
      const cart = await CartDrawer.fetchCart();
      CartDrawer.updateBadge(cart);
      await this.render();
      this.open();
      document.dispatchEvent(new CustomEvent('cart:updated', { detail: cart }));
      return added;
    }

    async applyPromo(code) {
      if (!code) return;
      try {
        await fetch('/discount/' + encodeURIComponent(code), { method: 'GET', credentials: 'same-origin' });
        const cart = await CartDrawer.fetchCart();
        CartDrawer.updateBadge(cart);
        await this.render();
      } catch (_) { /* ignore */ }
    }

    wireInner() {
      const drawer = this.dialog;
      if (!drawer) return;

      const closeBtn = drawer.querySelector('[data-cart-drawer-close]');
      if (closeBtn) closeBtn.addEventListener('click', () => this.close());

      drawer.querySelectorAll('[data-stepper]').forEach(stepper => {
        const input = stepper.querySelector('[data-stepper-input]');
        const li = stepper.closest('[data-line-key]');
        const key = li && li.dataset.lineKey;
        const dec = stepper.querySelector('[data-stepper-dec]');
        const inc = stepper.querySelector('[data-stepper-inc]');
        if (dec) dec.addEventListener('click', () => {
          const q = Math.max(0, (parseInt(input.value, 10) || 0) - 1);
          input.value = q; if (key) this.update(key, q);
        });
        if (inc) inc.addEventListener('click', () => {
          const q = (parseInt(input.value, 10) || 0) + 1;
          input.value = q; if (key) this.update(key, q);
        });
        input.addEventListener('change', () => {
          const q = Math.max(0, parseInt(input.value, 10) || 0);
          input.value = q; if (key) this.update(key, q);
        });
      });

      drawer.querySelectorAll('[data-cart-remove]').forEach(btn => {
        const li = btn.closest('[data-line-key]');
        const key = li && li.dataset.lineKey;
        btn.addEventListener('click', () => { if (key) this.update(key, 0); });
      });

      const promoBtn = drawer.querySelector('[data-promo-apply]');
      const promoInput = drawer.querySelector('#cart-drawer-promo-input');
      if (promoBtn && promoInput) {
        promoBtn.addEventListener('click', () => this.applyPromo(promoInput.value.trim()));
        promoInput.addEventListener('keydown', (e) => {
          if (e.key === 'Enter') {
            e.preventDefault();
            this.applyPromo(promoInput.value.trim());
          }
        });
      }
    }
  }

  if (!customElements.get('cart-drawer')) customElements.define('cart-drawer', CartDrawer);

  // Backward-compat shim: window.MMCart proxies to the first <cart-drawer> instance.
  const drawerEl = () => document.querySelector('cart-drawer');
  window.MMCart = {
    open: () => drawerEl()?.open(),
    close: () => drawerEl()?.close(),
    add: (id, qty) => drawerEl()?.add(id, qty),
    update: (key, qty) => drawerEl()?.update(key, qty),
    render: () => drawerEl()?.render(),
  };


  /* ─── Cart note ──────────────────────────────────────────────────────────
     The drawer checks out through a plain <a href="/cart/checkout">, so there
     is no form post for a `name="note"` field to travel with — the note has to
     be written to the cart over the AJAX API before the shopper leaves.

     Saved on `change` (fires on blur) AND debounced on `input`, because a
     shopper who types a note and clicks straight through to checkout never
     blurs the field; without the debounce their note is lost. Delegated from
     document so it survives the drawer re-rendering its own markup. */
  (() => {
    const SAVE_AFTER_MS = 600;
    let timer = null;
    let inFlight = null;

    function save(value) {
      if (inFlight) inFlight.abort();
      inFlight = new AbortController();
      return fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ note: value }),
        signal: inFlight.signal,
        keepalive: true, // let it complete if the shopper navigates to checkout
      }).catch(() => { /* a dropped note must not break checkout */ });
    }

    document.addEventListener('input', (e) => {
      const el = e.target;
      if (!el || !el.matches || !el.matches('[data-cart-note]')) return;
      clearTimeout(timer);
      timer = setTimeout(() => save(el.value), SAVE_AFTER_MS);
    });

    document.addEventListener('change', (e) => {
      const el = e.target;
      if (!el || !el.matches || !el.matches('[data-cart-note]')) return;
      clearTimeout(timer);
      save(el.value);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  (() => {
    const mq = window.matchMedia('(min-width: 60rem)');
    function syncDetails() {
      const open = mq.matches;
      document.querySelectorAll('.footer__col').forEach(d => {
        if (open) d.setAttribute('open', '');
      });
    }
    syncDetails();
    if (mq.addEventListener) mq.addEventListener('change', syncDetails);
    else mq.addListener(syncDetails);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  (() => {
    const hamburger = document.getElementById('hamburger-btn');
    if (hamburger) {
      hamburger.addEventListener('click', () => {
        if (!window.MMNavDrawer) return;
        window.MMNavDrawer.open();
      });
      document.addEventListener('nav:opened', () => hamburger.setAttribute('aria-expanded', 'true'));
      document.addEventListener('nav:closed', () => hamburger.setAttribute('aria-expanded', 'false'));
    }

    // Mobile search toggle — Figma keeps the main row compact and exposes
    // search behind an icon rather than as a persistent inline bar.
    const mobileSearchToggle = document.querySelector('[data-mobile-search-toggle]');
    const mobileSearchWrap = document.querySelector('[data-predictive-search-mobile-wrap]');
    if (mobileSearchToggle && mobileSearchWrap) {
      mobileSearchToggle.addEventListener('click', () => {
        const open = mobileSearchWrap.hasAttribute('hidden');
        if (open) {
          mobileSearchWrap.removeAttribute('hidden');
          mobileSearchToggle.setAttribute('aria-expanded', 'true');
          const input = mobileSearchWrap.querySelector('input[type="search"]');
          if (input) input.focus();
        } else {
          mobileSearchWrap.setAttribute('hidden', '');
          mobileSearchToggle.setAttribute('aria-expanded', 'false');
        }
      });
    }

    /* ─── Predictive search ─────────────────────────────────────────────
       Each [data-predictive-search] container wraps a form with an input
       and a panel. On focus we open the panel; on input (debounced) we
       fetch /search/suggest.json and render product results.
    */
    const predictiveContainers = document.querySelectorAll('[data-predictive-search]');
    predictiveContainers.forEach((container) => {
      const input = container.querySelector('[data-predictive-input]');
      const panelId = input && input.getAttribute('aria-controls');
      const panel = panelId ? document.getElementById(panelId) : null;
      if (!input || !panel) return;

      const list = panel.querySelector('[data-predictive-list]');
      const hint = panel.querySelector('[data-predictive-hint]');
      const empty = panel.querySelector('[data-predictive-empty]');
      const loading = panel.querySelector('[data-predictive-loading]');
      const viewAll = panel.querySelector('[data-predictive-view-all]');

      let timer = null;
      let lastQuery = '';
      let abortCtl = null;

      function setState(state) {
        if (hint) hint.hidden = state !== 'idle';
        if (empty) empty.hidden = state !== 'empty';
        if (loading) loading.hidden = state !== 'loading';
      }

      function onOutsideClick(e) {
        if (!container.contains(e.target) && !panel.contains(e.target)) hidePanel();
      }
      function showPanel() {
        panel.hidden = false;
        input.setAttribute('aria-expanded', 'true');
        // Defer attaching the outside-click listener so the same click that
        // opened the panel (e.g. the mobile-search toggle button which lives
        // outside the predictive container) doesn't immediately close it.
        setTimeout(() => document.addEventListener('click', onOutsideClick), 0);
      }
      function hidePanel() {
        panel.hidden = true;
        input.setAttribute('aria-expanded', 'false');
        document.removeEventListener('click', onOutsideClick);
      }

      function renderProducts(products, q) {
        if (!list) return;
        list.replaceChildren();
        if (!products || products.length === 0) {
          setState('empty');
          if (viewAll) viewAll.hidden = true;
          return;
        }
        setState('results');
        for (const p of products) {
          const li = document.createElement('li');
          li.className = 'predictive-search__item';
          const a = document.createElement('a');
          a.className = 'predictive-search__link';
          a.href = p.url;
          // media
          const media = document.createElement('div');
          media.className = 'predictive-search__media';
          if (p.image) {
            const img = document.createElement('img');
            img.src = p.image;
            img.alt = '';
            img.loading = 'lazy';
            media.appendChild(img);
          }
          // body
          const body = document.createElement('div');
          body.className = 'predictive-search__body';
          if (p.vendor) {
            const v = document.createElement('span');
            v.className = 'predictive-search__vendor';
            v.textContent = p.vendor;
            body.appendChild(v);
          }
          const t = document.createElement('span');
          t.className = 'predictive-search__title';
          t.textContent = p.title;
          body.appendChild(t);
          // price
          const price = document.createElement('span');
          price.className = 'predictive-search__price';
          price.textContent = p.price || '';
          a.append(media, body, price);
          li.appendChild(a);
          list.appendChild(li);
        }
        if (viewAll) {
          viewAll.hidden = false;
          viewAll.href = '/search?q=' + encodeURIComponent(q);
        }
      }

      function fetchResults(q) {
        if (abortCtl) abortCtl.abort();
        abortCtl = new AbortController();
        setState('loading');
        if (list) list.replaceChildren();
        // `resources[options][fields]` must mirror snippets/search-fields-input
        // — the predictive endpoint has the same default field list as the full
        // search and likewise omits variants.sku, so without this a part number
        // returns nothing in the dropdown even though the results page finds it.
        // Supplying the option REPLACES the defaults, hence the full list.
        const url = '/search/suggest.json?q=' + encodeURIComponent(q)
          + '&resources[type]=product&resources[limit]=8'
          + '&resources[options][unavailable_products]=last'
          + '&resources[options][fields]=title,product_type,vendor,variants.title,variants.sku,tag';
        fetch(url, { signal: abortCtl.signal, headers: { 'Accept': 'application/json' } })
          .then((r) => r.json())
          .then((data) => {
            const products = (data && data.resources && data.resources.results && data.resources.results.products) || [];
            renderProducts(products, q);
          })
          .catch((err) => {
            if (err && err.name === 'AbortError') return;
            setState('idle');
          });
      }

      input.addEventListener('focus', () => {
        showPanel();
        if (input.value.trim().length < 2) setState('idle');
      });
      input.addEventListener('input', () => {
        const q = input.value.trim();
        if (q === lastQuery) return;
        lastQuery = q;
        if (timer) clearTimeout(timer);
        if (q.length < 2) {
          setState('idle');
          if (list) list.replaceChildren();
          if (viewAll) viewAll.hidden = true;
          return;
        }
        timer = setTimeout(() => fetchResults(q), 200);
      });
      input.addEventListener('keydown', (e) => {
        if (e.key === 'Escape') {
          hidePanel();
          input.blur();
        }
      });
    });

    /* ─── Mega menu — click-to-toggle ───────────────────────────────────
       Clicking a parent nav link expands its mega menu instead of
       navigating. The "Shop all <Name>" link inside the mega menu is the
       navigation target. Right-click / Cmd+click still works because the
       <a href> is preserved. */
    const megaItems = [...document.querySelectorAll('.desktop-nav__item.has-mega')];
    function closeAllMega(except) {
      megaItems.forEach((it) => {
        if (it === except) return;
        if (it.dataset.open === 'true') {
          it.dataset.open = 'false';
          const l = it.querySelector('[data-mega-toggle]');
          if (l) l.setAttribute('aria-expanded', 'false');
        }
      });
    }
    function openMega(item) {
      closeAllMega(item);
      item.dataset.open = 'true';
      const l = item.querySelector('[data-mega-toggle]');
      if (l) l.setAttribute('aria-expanded', 'true');
    }
    function closeMega(item) {
      item.dataset.open = 'false';
      const l = item.querySelector('[data-mega-toggle]');
      if (l) l.setAttribute('aria-expanded', 'false');
    }

    megaItems.forEach((item) => {
      const link = item.querySelector('[data-mega-toggle]');
      const mega = item.querySelector('.mega-menu');
      if (!link || !mega) return;

      link.addEventListener('click', (e) => {
        // Allow modifier-clicks (open in new tab/window) to follow the href.
        if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || e.button === 1) return;
        e.preventDefault();
        if (item.dataset.open === 'true') closeMega(item);
        else openMega(item);
      });

      link.addEventListener('keydown', (e) => {
        if (e.key === 'Enter' || e.key === ' ' || e.key === 'ArrowDown') {
          e.preventDefault();
          openMega(item);
          if (e.key === 'ArrowDown') {
            const first = mega.querySelector('a');
            if (first) first.focus();
          }
        }
      });

      item.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && item.dataset.open === 'true') {
          closeMega(item);
          link.focus();
        }
      });
    });

    // Click outside any mega-item closes all.
    document.addEventListener('click', (e) => {
      if (!megaItems.some((it) => it.contains(e.target))) closeAllMega(null);
    });

    const header = document.querySelector('.site-header[data-sticky="true"]');
    if (header) {
      let lastY = window.scrollY;
      let ticking = false;
      let stopTimer = null;
      const HIDE_THRESHOLD = 120;   // px from top before hiding kicks in
      const STOP_DELAY = 220;       // ms of no-scroll before header reappears

      const showHeader = () => { header.dataset.hidden = 'false'; header.style.transform = ''; };
      const hideHeader = () => { header.dataset.hidden = 'true'; header.style.transform = 'translateY(-100%)'; };

      window.addEventListener('scroll', () => {
        if (!ticking) {
          window.requestAnimationFrame(() => {
            const y = window.scrollY;
            const goingDown = y > lastY;
            if (y <= HIDE_THRESHOLD) {
              showHeader();
            } else if (goingDown) {
              hideHeader();
            } else {
              showHeader();
            }
            lastY = y; ticking = false;
          });
          ticking = true;
        }
        // Debounced "scroll stopped" → reappear
        if (stopTimer) clearTimeout(stopTimer);
        stopTimer = setTimeout(showHeader, STOP_DELAY);
      }, { passive: true });

      header.style.transition = 'transform 280ms cubic-bezier(0.22, 1, 0.36, 1)';
      header.dataset.hidden = 'false';
    }

    // Cart drawer trigger — bind regardless of bike-bar presence.
    document.querySelectorAll('[data-cart-drawer-open]').forEach(btn => {
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        if (window.MMCart) window.MMCart.open();
      });
    });

    const bar = document.querySelector('[data-bike-bar]');
    if (!bar) return;

    // Payload ships as assets/bike-selector-data.js; see the bike-selector-data
    // snippet for why it is not built inline from the metaobjects.
    const data = window.BIKE_SELECTOR_DATA || { manufacturers: [] };

    const makeEl = bar.querySelector('[data-bike-make]');
    const modelEl = bar.querySelector('[data-bike-model]');
    const yearEl = bar.querySelector('[data-bike-year]');

    // `options` entries are either a plain string (value === text) or a
    // { value, text } pair. The model dropdown needs the pair form: its
    // option VALUE stays the canonical make-prefixed model name (the fitment
    // matching key) while the visible text drops the redundant make.
    function populate(select, options, placeholder) {
      const first = document.createElement('option');
      first.value = '';
      first.textContent = placeholder;
      const kids = [first];
      options.forEach(o => {
        const opt = document.createElement('option');
        if (o && typeof o === 'object') {
          opt.value = o.value; opt.textContent = o.text;
        } else {
          opt.value = o; opt.textContent = o;
        }
        kids.push(opt);
      });
      select.replaceChildren(...kids);
    }

    const manufacturers = data.manufacturers || [];
    populate(makeEl, manufacturers.map(m => m.name), makeEl.options[0].text);

    /* ─── Model display labels ────────────────────────────────────────────
       Model metaobject names are stored make-prefixed ("BMW R1300GS"), so
       anything that prints make + model naively reads "BMW BMW R1300GS".
       Only DISPLAY strings go through these helpers. The value written to
       the mm_garage cookie, used to build a bike id, or compared against a
       product's bike.model metafield is always the untouched `name`.

       `assets/bike-selector-data.js` already emits a per-model `label`, which is
       authoritative because it was computed with the model's parent make in
       hand. stripMakePrefix is the fallback for a bike restored from a cookie
       whose model is no longer in the catalog, so there is no `label` to read.
       Keep the two rules in step if either changes. */
    function stripMakePrefix(modelName, makeName) {
      if (!modelName || !makeName) return modelName || '';
      const prefix = makeName + ' ';
      if (modelName.slice(0, prefix.length).toLowerCase() !== prefix.toLowerCase()) {
        return modelName;
      }
      // Only the first occurrence, and never strip down to nothing.
      return modelName.slice(prefix.length).replace(/^\s+/, '') || modelName;
    }
    function modelLabel(makeName, modelName) {
      const mfg = manufacturers.find(m => m.name === makeName);
      const model = mfg && mfg.models.find(x => x.name === modelName);
      if (model && model.label) return model.label;
      return stripMakePrefix(modelName, makeName);
    }
    /* Display name for a saved bike — "2024 BMW R1300GS", not "2024 BMW BMW R1300GS". */
    function bikeLabel(bike) {
      return bike.year + ' ' + bike.manufacturer + ' ' + modelLabel(bike.manufacturer, bike.model);
    }
    function modelOptions(mfg) {
      return mfg ? mfg.models.map(x => ({ value: x.name, text: x.label || x.name })) : [];
    }

    function makeObj() {
      return manufacturers.find(m => m.name === makeEl.value);
    }
  function modelYears(m) {
    if (!m || !m.years) return [];
    return Array.isArray(m.years) ? m.years : String(m.years).split(',').filter(Boolean);
  }
    function modelObj() {
      const m = makeObj();
      return m ? m.models.find(x => x.name === modelEl.value) : null;
    }

    makeEl.addEventListener('change', () => {
      const m = makeObj();
      modelEl.disabled = !m;
      yearEl.disabled = true;
      populate(modelEl, modelOptions(m), modelEl.options[0].text);
      populate(yearEl, [], yearEl.options[0].text);
    });
    modelEl.addEventListener('change', () => {
      const m = modelObj();
      yearEl.disabled = !m;
      populate(yearEl, modelYears(m), yearEl.options[0].text);
    });

    const COOKIE = 'mm_garage';
    function readGarage() {
      const m = document.cookie.match(new RegExp('(?:^|; )' + COOKIE + '=([^;]*)'));
      if (!m) return { v: 1, bikes: [], activeBikeId: null };
      try { return JSON.parse(decodeURIComponent(m[1])); } catch { return { v: 1, bikes: [], activeBikeId: null }; }
    }
    function writeGarage(state) {
      const val = encodeURIComponent(JSON.stringify(state));
      const exp = new Date(Date.now() + 365 * 24 * 60 * 60 * 1000).toUTCString();
      const secure = location.protocol === 'https:' ? '; Secure' : '';
      document.cookie = COOKIE + '=' + val + '; expires=' + exp + '; path=/; SameSite=Lax' + secure;
      // Sync to customer metafield via App Proxy (logged-in customers only).
      // Debounced so a flurry of changes coalesces into a single POST.
      scheduleCustomerSync(state);
    }

    let _syncTimer = null;
    let _syncCtl = null;
    function scheduleCustomerSync(state) {
      if (!window.MM_CUSTOMER_LOGGED_IN) return;
      const url = window.MM_GARAGE_SYNC_URL;
      if (!url) return;
      if (_syncTimer) clearTimeout(_syncTimer);
      _syncTimer = setTimeout(() => {
        if (_syncCtl) _syncCtl.abort();
        _syncCtl = new AbortController();
        fetch(url, {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ bikes: state.bikes || [], activeBikeId: state.activeBikeId || null }),
          signal: _syncCtl.signal,
          keepalive: true
        }).catch(() => { /* App Proxy not deployed yet — ignore. Cookie remains source of truth. */ });
      }, 800);
    }

    const garage = readGarage();
    if (window.MM_CUSTOMER_GARAGE && Array.isArray(window.MM_CUSTOMER_GARAGE.bikes)) {
      const seen = new Set(garage.bikes.map(b => b.id));
      let merged = false;
      window.MM_CUSTOMER_GARAGE.bikes.forEach(b => {
        if (!seen.has(b.id)) { garage.bikes.push(b); merged = true; }
      });
      if (window.MM_CUSTOMER_GARAGE.activeBikeId && !garage.activeBikeId) {
        garage.activeBikeId = window.MM_CUSTOMER_GARAGE.activeBikeId;
        merged = true;
      }
      if (merged) writeGarage(garage);
    }

    const barEl = document.querySelector('.bike-bar');
    const summaryEl = document.querySelector('[data-bike-summary]');
    const labelEl = document.querySelector('[data-bike-label]');
    const shopLinkEl = document.querySelector('[data-bike-shop]');
    const changeBtnEl = document.querySelector('[data-bike-change]');

    /* Resolve the destination URL for a (bike, model) pair. Always routes
       to the model's collection — `model.collectionUrl` if the metaobject
       has the field set, else `/collections/<model.handle>` (the per-model
       collection convention). Year is appended as a storefront filter. */
    function bikeDestination(bike, model) {
      const modelHandle = (model && model.handle) || bike.modelHandle || null;
      let base;
      if (model && model.collectionUrl) {
        base = model.collectionUrl;
      } else if (modelHandle) {
        base = '/collections/' + modelHandle;
      } else {
        // Last-resort: legacy fallback to the manufacturer collection. Only
        // hit when both the model metaobject's collectionUrl is unset AND no
        // modelHandle is available on the saved bike (pre-migration cookies).
        base = '/collections/' + bike.manufacturerHandle;
      }
      const sep = base.includes('?') ? '&' : '?';
      return base + sep + 'filter.p.m.bike.year=' + encodeURIComponent(bike.year);
    }

    function showSummary(bike) {
      if (!barEl || !summaryEl || !labelEl || !shopLinkEl) return;
      labelEl.textContent = bikeLabel(bike);
      const mfg = manufacturers.find(m => m.name === bike.manufacturer);
      const model = mfg && mfg.models.find(m => m.name === bike.model);
      shopLinkEl.href = bikeDestination(bike, model);
      barEl.dataset.state = 'selected';
      summaryEl.hidden = false;
    }
    function showPicker() {
      if (!barEl || !summaryEl) return;
      barEl.dataset.state = 'picker';
      summaryEl.hidden = true;
      makeEl.focus();
    }
    if (changeBtnEl) changeBtnEl.addEventListener('click', showPicker);

    let isInitializing = true;
    const active = garage.bikes.find(b => b.id === garage.activeBikeId) || garage.bikes[0];
    if (active) {
      makeEl.value = active.manufacturer;
      makeEl.dispatchEvent(new Event('change'));
      modelEl.value = active.model;
      modelEl.dispatchEvent(new Event('change'));
      yearEl.value = active.year;
      yearEl.dispatchEvent(new Event('change'));
      showSummary(active);
    } else if (barEl) {
      barEl.dataset.state = 'picker';
    }
    isInitializing = false;

    function navigateForSelection() {
      const mfg = manufacturers.find(m => m.name === makeEl.value);
      if (!mfg || !modelEl.value || !yearEl.value) return;
      const model = mfg.models.find(m => m.name === modelEl.value);

      const bike = {
        id: yearEl.value + '-' + mfg.handle + '-' + modelEl.value.replace(/\s+/g, '-').toLowerCase(),
        manufacturer: mfg.name,
        manufacturerHandle: mfg.handle,
        model: modelEl.value,
        modelHandle: model && model.handle ? model.handle : null,
        year: yearEl.value,
        addedAt: new Date().toISOString()
      };
      const g = readGarage();
      if (!g.bikes.some(b => b.id === bike.id)) g.bikes.push(bike);
      g.activeBikeId = bike.id;
      writeGarage(g);
      showSummary(bike);

      window.location.href = bikeDestination(bike, model);
    }

    // Auto-navigate when the user picks a year (the last step of the cascade).
    // Skip during initialization (pre-filling from the garage cookie would otherwise trigger).
    yearEl.addEventListener('change', () => {
      if (isInitializing) return;
      if (yearEl.value) navigateForSelection();
    });

    // Guard against accidental form submit (no submit button exists, but Enter may still fire it).
    bar.addEventListener('submit', (e) => {
      e.preventDefault();
      if (yearEl.value) navigateForSelection();
    });

    document.querySelectorAll('[data-bike-selector-focus]').forEach(el => {
      el.addEventListener('click', (e) => {
        e.preventDefault();
        makeEl.focus();
        makeEl.scrollIntoView({ behavior: 'smooth', block: 'center' });
      });
    });

    /* ─── Garage dropdown ─────────────────────────────────────────────── */
    const garageMenu = document.querySelector('[data-garage-menu]');
    if (garageMenu) {
      const toggle = garageMenu.querySelector('[data-garage-toggle]');
      const panel = garageMenu.querySelector('[data-garage-panel]');
      const countEl = garageMenu.querySelector('[data-garage-count]');
      const empty = garageMenu.querySelector('[data-garage-empty]');
      const listWrap = garageMenu.querySelector('[data-garage-list-wrap]');
      const list = garageMenu.querySelector('[data-garage-list]');
      const SVG_NS = 'http://www.w3.org/2000/svg';

      function focusBikePicker() {
        if (typeof makeEl !== 'undefined' && makeEl) {
          makeEl.focus();
          makeEl.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
      }

      function buildRemoveSvg() {
        const svg = document.createElementNS(SVG_NS, 'svg');
        svg.setAttribute('class', 'garage-menu__remove-icon');
        svg.setAttribute('viewBox', '0 0 24 24');
        svg.setAttribute('fill', 'none');
        svg.setAttribute('stroke', 'currentColor');
        svg.setAttribute('stroke-width', '2');
        svg.setAttribute('aria-hidden', 'true');
        const l1 = document.createElementNS(SVG_NS, 'line');
        l1.setAttribute('x1', '18'); l1.setAttribute('y1', '6');
        l1.setAttribute('x2', '6');  l1.setAttribute('y2', '18');
        const l2 = document.createElementNS(SVG_NS, 'line');
        l2.setAttribute('x1', '6');  l2.setAttribute('y1', '6');
        l2.setAttribute('x2', '18'); l2.setAttribute('y2', '18');
        svg.append(l1, l2);
        return svg;
      }

      function renderGarage() {
        const g = readGarage();
        const bikes = (g && g.bikes) || [];
        if (countEl) {
          countEl.textContent = String(bikes.length);
          countEl.dataset.empty = bikes.length === 0 ? 'true' : 'false';
        }
        if (bikes.length === 0) {
          if (empty) empty.hidden = false;
          if (listWrap) listWrap.hidden = true;
          return;
        }
        if (empty) empty.hidden = true;
        if (listWrap) listWrap.hidden = false;
        if (!list) return;
        list.replaceChildren();
        for (const bike of bikes) {
          const li = document.createElement('li');
          li.className = 'garage-menu__list-item';
          li.dataset.active = (bike.id === g.activeBikeId).toString();

          const btn = document.createElement('button');
          btn.type = 'button';
          btn.className = 'garage-menu__bike-btn';
          const name = document.createElement('span');
          name.className = 'garage-menu__bike-name';
          name.textContent = bikeLabel(bike);
          const state = document.createElement('span');
          state.className = 'garage-menu__bike-state';
          state.textContent = 'Active';
          btn.append(name, state);
          btn.addEventListener('click', () => {
            const next = readGarage();
            next.activeBikeId = bike.id;
            writeGarage(next);
            document.dispatchEvent(new CustomEvent('garage:changed', { detail: { bike } }));
            renderGarage();
            try { showSummary(bike); } catch (_) {}
            closePanel();
            // Route to the bike's model collection with year filter applied.
            const mfg = manufacturers.find(m => m.handle === bike.manufacturerHandle);
            const model = mfg && mfg.models.find(m => m.name === bike.model);
            window.location.href = bikeDestination(bike, model);
          });

          const rm = document.createElement('button');
          rm.type = 'button';
          rm.className = 'garage-menu__remove';
          rm.setAttribute('aria-label', 'Remove ' + bikeLabel(bike));
          rm.append(buildRemoveSvg());
          rm.addEventListener('click', (e) => {
            e.stopPropagation();
            const next = readGarage();
            next.bikes = (next.bikes || []).filter(b => b.id !== bike.id);
            if (next.activeBikeId === bike.id) {
              next.activeBikeId = next.bikes.length ? next.bikes[0].id : null;
            }
            writeGarage(next);
            document.dispatchEvent(new CustomEvent('garage:changed'));
            renderGarage();
          });

          li.append(btn, rm);
          list.append(li);
        }
      }

      function openPanel() {
        if (!panel) return;
        renderGarage();
        panel.hidden = false;
        toggle.setAttribute('aria-expanded', 'true');
        setTimeout(() => document.addEventListener('click', onOutside), 0);
      }
      function closePanel() {
        if (!panel) return;
        panel.hidden = true;
        toggle.setAttribute('aria-expanded', 'false');
        document.removeEventListener('click', onOutside);
      }
      function onOutside(e) {
        if (!garageMenu.contains(e.target)) closePanel();
      }

      toggle.addEventListener('click', () => {
        if (panel.hidden) openPanel();
        else closePanel();
      });

      /* Modal — self-contained Make/Model/Year picker. Saves to garage and closes. */
      const modal = document.querySelector('[data-garage-modal]');
      const modalDialog = modal && modal.querySelector('.garage-modal__dialog');
      const modalMake = modal && modal.querySelector('[data-garage-modal-make]');
      const modalModel = modal && modal.querySelector('[data-garage-modal-model]');
      const modalYear = modal && modal.querySelector('[data-garage-modal-year]');
      const modalSave = modal && modal.querySelector('[data-garage-modal-save]');
      let modalLastFocus = null;
      let modalKeyHandler = null;

      // Same value/text contract as populate() above: a plain string, or a
      // { value, text } pair when the two must differ (the model dropdown).
      function modalPopulate(select, items, placeholder) {
        select.replaceChildren();
        const ph = document.createElement('option');
        ph.value = '';
        ph.textContent = placeholder;
        select.appendChild(ph);
        for (const v of items) {
          const opt = document.createElement('option');
          if (v && typeof v === 'object') {
            opt.value = v.value;
            opt.textContent = v.text;
          } else {
            opt.value = v;
            opt.textContent = v;
          }
          select.appendChild(opt);
        }
      }
      function modalFindMfg() {
        return manufacturers.find(m => m.name === modalMake.value);
      }
      function modalFindModel() {
        const mfg = modalFindMfg();
        if (!mfg) return null;
        return mfg.models.find(m => m.name === modalModel.value);
      }
      function modalRefreshSave() {
        const ok = modalMake.value && modalModel.value && modalYear.value;
        modalSave.disabled = !ok;
      }

      // Snapshot the rendered placeholders so we can restore them later.
      // (Translations cannot be inlined here because this block is static JS.)
      const phMake = modalMake ? modalMake.options[0]?.textContent || 'Select Make' : '';
      const phModel = modalModel ? modalModel.options[0]?.textContent || 'Select Model' : '';
      const phYear = modalYear ? modalYear.options[0]?.textContent || 'Select Year' : '';

      function openModal() {
        if (!modal) return;
        modalLastFocus = document.activeElement;
        // Re-populate makes from the same source as the bike-bar
        modalPopulate(modalMake, manufacturers.map(m => m.name), phMake);
        modalPopulate(modalModel, [], phModel);
        modalPopulate(modalYear, [], phYear);
        modalModel.disabled = true;
        modalYear.disabled = true;
        modalSave.disabled = true;
        modal.hidden = false;
        document.documentElement.style.overflow = 'hidden';
        modalKeyHandler = (e) => {
          if (e.key === 'Escape') closeModal();
        };
        document.addEventListener('keydown', modalKeyHandler);
        setTimeout(() => modalMake.focus(), 0);
      }
      function closeModal() {
        if (!modal) return;
        modal.hidden = true;
        document.documentElement.style.overflow = '';
        if (modalKeyHandler) document.removeEventListener('keydown', modalKeyHandler);
        modalKeyHandler = null;
        if (modalLastFocus && typeof modalLastFocus.focus === 'function') modalLastFocus.focus();
      }

      if (modal && modalMake && modalModel && modalYear && modalSave) {
        modalMake.addEventListener('change', () => {
          const mfg = modalFindMfg();
          modalModel.disabled = !mfg;
          modalPopulate(modalModel, modelOptions(mfg), phModel);
          modalYear.disabled = true;
          modalPopulate(modalYear, [], phYear);
          modalRefreshSave();
        });
        modalModel.addEventListener('change', () => {
          const m = modalFindModel();
          modalYear.disabled = !m;
          modalPopulate(modalYear, modelYears(m), phYear);
          modalRefreshSave();
        });
        modalYear.addEventListener('change', modalRefreshSave);

        modalSave.addEventListener('click', () => {
          const mfg = modalFindMfg();
          if (!mfg || !modalModel.value || !modalYear.value) return;
          const model = modalFindModel();
          const bike = {
            id: modalYear.value + '-' + mfg.handle + '-' + modalModel.value.replace(/\s+/g, '-').toLowerCase(),
            manufacturer: mfg.name,
            manufacturerHandle: mfg.handle,
            model: modalModel.value,
            modelHandle: model && model.handle ? model.handle : null,
            year: modalYear.value,
            addedAt: new Date().toISOString()
          };
          const g = readGarage();
          if (!g.bikes.some(b => b.id === bike.id)) g.bikes.push(bike);
          g.activeBikeId = bike.id;
          writeGarage(g);
          document.dispatchEvent(new CustomEvent('garage:changed', { detail: { bike } }));
          try { showSummary(bike); } catch (_) {}
          renderGarage();
          closeModal();
          // Take the user to the model's collection with the year filter applied.
          window.location.href = bikeDestination(bike, model);
        });

        modal.querySelectorAll('[data-garage-modal-close]').forEach((el) => {
          el.addEventListener('click', closeModal);
        });
      }

      garageMenu.querySelectorAll('[data-garage-add]').forEach((btn) => {
        btn.addEventListener('click', () => {
          closePanel();
          openModal();
        });
      });

      renderGarage();
      document.addEventListener('garage:changed', renderGarage);
    }
  })();

  /* ─── Signed-in account avatar ring ──────────────────────────────────────
     A customer signed in with Shop gets the "coin" avatar, whose ring is drawn
     as:
         .account-button--shop-customer .account-button__coin-front:after {
           box-shadow: inset 0 0 0 var(--ring-width) var(--shop-brand-color);
         }
     `--shop-brand-color` is Shop's brand purple (#5433eb) and is declared on
     #shopify-element-wrapper INSIDE the component's shadow root. A custom
     property set on an inner element beats one inherited from the host, so no
     amount of outer CSS on <shopify-account> can override it — that is why
     setting --shopify-account-* on .site-header__account recoloured the plain
     signed-in avatar but left this ring purple.

     The shadow root is attachShadow({mode:"open"}), so a stylesheet can be
     appended to it from script. Only `dialog` and `signed-out-avatar` are
     exposed as ::part, so there is no supported hook for the coin.

     This deliberately overrides the RING only, not --shop-brand-color itself:
     the coin's front and back faces use the same variable as their fill, so
     recolouring the variable would turn the whole avatar white and make it
     disappear against the header.

     Reaching into a third-party component is a known risk. If Shopify renames
     these classes the selector stops matching and the ring simply returns to
     purple — it cannot break the header. */
  (() => {
    const RING_CSS =
      '.account-button--shop-customer .account-button__coin-front::after{' +
      'box-shadow: inset 0 0 0 var(--ring-width, 2px) var(--color-white, #fff) !important;}';

    function inject(host) {
      const root = host && host.shadowRoot;
      if (!root || root.querySelector('style[data-mm-account-ring]')) return !!root;
      const style = document.createElement('style');
      style.setAttribute('data-mm-account-ring', '');
      style.textContent = RING_CSS;
      root.appendChild(style);
      return true;
    }

    function start() {
      const host = document.querySelector('shopify-account');
      if (!host) return;
      if (inject(host)) return;
      // The shadow root is attached during upgrade, which may not have happened
      // yet. Watch briefly rather than polling forever.
      let tries = 0;
      const timer = setInterval(() => {
        if (inject(host) || ++tries > 40) clearInterval(timer);
      }, 100);
    }

    if (window.customElements && customElements.whenDefined) {
      customElements.whenDefined('shopify-account').then(start).catch(start);
    }
    start();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const root = document.querySelector('[data-cart-section]');
    if (!root) return;

    /* Quantity stepper buttons */
    root.addEventListener('click', (e) => {
      const btn = e.target.closest('[data-qty-change]');
      if (!btn) return;
      const item = btn.closest('[data-cart-item]');
      if (!item) return;
      const input = item.querySelector('[data-line-quantity]');
      if (!input) return;
      const change = Number(btn.dataset.qtyChange);
      const newVal = Math.max(0, Number(input.value || 0) + change);
      input.value = newVal;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });

    /* Auto-update line quantity via Cart AJAX API on change */
    root.addEventListener('change', async (e) => {
      const input = e.target.closest('[data-line-quantity]');
      if (!input) return;

      const item = input.closest('[data-cart-item]');
      const key = item && item.dataset.key;
      const qty = Math.max(0, Number(input.value || 0));
      if (!key) return;

      try {
        const res = await fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ id: key, quantity: qty })
        });
        const cart = await res.json();
        if (qty === 0) {
          item.remove();
        } else {
          const lineItem = (cart.items || []).find((i) => i.key === key);
          if (lineItem) {
            const linePrice = item.querySelector('[data-line-price]');
            if (linePrice) {
              linePrice.textContent = formatMoney(lineItem.final_line_price);
            }
          }
        }
        const subtotal = root.querySelector('[data-cart-subtotal]');
        if (subtotal) subtotal.textContent = formatMoney(cart.items_subtotal_price);
        const total = root.querySelector('[data-cart-total]');
        if (total) total.textContent = formatMoney(cart.total_price);
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: cart }));
        if ((cart.item_count || 0) === 0) {
          window.location.reload();
        }
      } catch (_) {
        /* fallback: full form submit */
        item.closest('form').submit();
      }
    });

    /* Remove link → AJAX remove */
    root.addEventListener('click', async (e) => {
      const link = e.target.closest('[data-remove-item]');
      if (!link) return;
      e.preventDefault();
      const item = link.closest('[data-cart-item]');
      const key = item && item.dataset.key;
      if (!key) return;
      try {
        const res = await fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ id: key, quantity: 0 })
        });
        const cart = await res.json();
        item.remove();
        const subtotal = root.querySelector('[data-cart-subtotal]');
        if (subtotal) subtotal.textContent = formatMoney(cart.items_subtotal_price);
        const total = root.querySelector('[data-cart-total]');
        if (total) total.textContent = formatMoney(cart.total_price);
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: cart }));
        if ((cart.item_count || 0) === 0) window.location.reload();
      } catch (_) {
        window.location.href = link.href;
      }
    });

    function formatMoney(cents) {
      try {
        return new Intl.NumberFormat(document.documentElement.lang || 'en-US', {
          style: 'currency',
          currency: window.Shopify && window.Shopify.currency
            ? window.Shopify.currency.active
            : 'USD'
        }).format(cents / 100);
      } catch (_) {
        return '$' + (cents / 100).toFixed(2);
      }
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  (() => {
    const root = document.querySelector('[data-collection-main]');
    if (!root) return;

    /* ─── Filter drawer (mobile) ─────────────────────────────────────── */
    const drawer = root.querySelector('[data-filter-drawer]');
    const overlay = root.querySelector('[data-filter-overlay]');
    const openBtn = root.querySelector('[data-filter-drawer-open]');
    const closeBtn = root.querySelector('[data-filter-drawer-close]');

    let lastFocused = null;

    function openDrawer() {
      if (!drawer) return;
      lastFocused = document.activeElement;
      drawer.dataset.open = 'true';
      if (overlay) {
        overlay.hidden = false;
        requestAnimationFrame(() => { overlay.dataset.open = 'true'; });
      }
      if (openBtn) openBtn.setAttribute('aria-expanded', 'true');
      const target = closeBtn || drawer.querySelector('input, button, a, summary');
      if (target instanceof HTMLElement) target.focus();
      document.addEventListener('keydown', onKey);
    }
    function closeDrawer() {
      if (!drawer) return;
      drawer.dataset.open = 'false';
      if (overlay) {
        overlay.dataset.open = 'false';
        setTimeout(() => { overlay.hidden = true; }, 350);
      }
      if (openBtn) openBtn.setAttribute('aria-expanded', 'false');
      document.removeEventListener('keydown', onKey);
      if (lastFocused instanceof HTMLElement) lastFocused.focus();
    }
    function onKey(e) {
      if (e.key === 'Escape') {
        closeDrawer();
        return;
      }
      if (e.key === 'Tab') trapFocus(e);
    }
    function trapFocus(e) {
      if (!drawer) return;
      const focusables = drawer.querySelectorAll(
        'a[href], button:not([disabled]), summary, input:not([disabled]), select:not([disabled]), [tabindex]:not([tabindex="-1"])'
      );
      if (!focusables.length) return;
      const first = focusables[0];
      const last = focusables[focusables.length - 1];
      if (e.shiftKey && document.activeElement === first) {
        last.focus();
        e.preventDefault();
      } else if (!e.shiftKey && document.activeElement === last) {
        first.focus();
        e.preventDefault();
      }
    }

    if (openBtn) openBtn.addEventListener('click', openDrawer);
    if (closeBtn) closeBtn.addEventListener('click', closeDrawer);
    if (overlay) overlay.addEventListener('click', closeDrawer);

    /* ─── Filter form: auto-submit on desktop, batched on mobile ─────── */
    const form = root.querySelector('[data-collection-filters]');
    if (form) {
      const isDesktop = () => window.matchMedia('(min-width: 960px)').matches;

      form.addEventListener('change', (e) => {
        const t = e.target;
        if (t && t.matches && t.matches('input[type="number"]')) return;
        if (isDesktop()) form.requestSubmit ? form.requestSubmit() : form.submit();
      });

      form.addEventListener('keydown', (e) => {
        if (e.key === 'Enter' && e.target.matches('input[type="number"]')) {
          e.preventDefault();
          form.requestSubmit ? form.requestSubmit() : form.submit();
        }
      });
      form.addEventListener('blur', (e) => {
        if (e.target.matches && e.target.matches('input[type="number"]') && isDesktop()) {
          if (e.target.value !== e.target.defaultValue) {
            form.requestSubmit ? form.requestSubmit() : form.submit();
          }
        }
      }, true);
    }

    /* ─── Bike-fit badges: read garage cookie, reveal matching badges ── */
    const COOKIE = 'mm_garage';
    function readGarage() {
      const m = document.cookie.match(new RegExp('(?:^|; )' + COOKIE + '=([^;]*)'));
      if (!m) return { v: 1, bikes: [], activeBikeId: null };
      try { return JSON.parse(decodeURIComponent(m[1])); }
      catch (_) { return { v: 1, bikes: [], activeBikeId: null }; }
    }

    /* Model metaobject names are stored make-prefixed ("BMW R1300GS"), so
       composing year + manufacturer + model naively reads "BMW BMW R1300GS".
       DISPLAY ONLY — `active.model` is still compared verbatim below, because
       it is the key matched against the product's bike.model values.
       Byte-identical to stripMakePrefix in sections/header.liquid and to
       model_label in migration/src/build_bike_selector.py; keep all three in
       step if the rule changes. */
    function stripMakePrefix(modelName, makeName) {
      if (!modelName || !makeName) return modelName || '';
      const prefix = makeName + ' ';
      if (modelName.slice(0, prefix.length).toLowerCase() !== prefix.toLowerCase()) {
        return modelName;
      }
      // Only the first occurrence, and never strip down to nothing.
      return modelName.slice(prefix.length).replace(/^\s+/, '') || modelName;
    }

    function applyFitBadges() {
      const garage = readGarage();
      if (!garage.bikes || !garage.bikes.length) return;
      const active =
        garage.bikes.find((b) => b.id === garage.activeBikeId) || garage.bikes[0];
      if (!active) return;

      root.querySelectorAll('[data-fit-badge]').forEach((el) => {
        const ms = (el.dataset.fitManufacturers || '').split('|').filter(Boolean);
        const md = (el.dataset.fitModels || '').split('|').filter(Boolean);
        const yr = (el.dataset.fitYears || '').split('|').filter(Boolean);

        // A product flagged universal fits every bike even when it carries
        // bike references, so short-circuit before comparing the lists.
        const universal =
          el.dataset.fitUniversal === 'true' ||
          (ms.length === 0 && md.length === 0 && yr.length === 0);

        if (universal) {
          el.textContent = 'Fits all bikes';
          el.hidden = false;
          return;
        }

        const fitsManufacturer =
          ms.length === 0 || ms.includes(active.manufacturerHandle);
        const fitsModel = md.length === 0 || md.includes(active.model);
        const fitsYear = yr.length === 0 || yr.includes(String(active.year));

        if (fitsManufacturer && fitsModel && fitsYear) {
          const model = stripMakePrefix(active.model, active.manufacturer);
          el.textContent = `✓ Fits your ${active.year} ${active.manufacturer} ${model}`;
          el.hidden = false;
        }
      });
    }

    applyFitBadges();
    document.addEventListener('garage:changed', applyFitBadges);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-search"]) return;
  try {
    
  (() => {
    const root = document.querySelector('[data-collection-main]');
    if (!root) return;

    /* ─── Filter drawer (mobile) — same logic as collection ─────────── */
    const drawer = root.querySelector('[data-filter-drawer]');
    const overlay = root.querySelector('[data-filter-overlay]');
    const openBtn = root.querySelector('[data-filter-drawer-open]');
    const closeBtn = root.querySelector('[data-filter-drawer-close]');

    let lastFocused = null;

    function openDrawer() {
      if (!drawer) return;
      lastFocused = document.activeElement;
      drawer.dataset.open = 'true';
      if (overlay) {
        overlay.hidden = false;
        requestAnimationFrame(() => { overlay.dataset.open = 'true'; });
      }
      if (openBtn) openBtn.setAttribute('aria-expanded', 'true');
      const target = closeBtn || drawer.querySelector('input, button, a, summary');
      if (target instanceof HTMLElement) target.focus();
      document.addEventListener('keydown', onKey);
    }
    function closeDrawer() {
      if (!drawer) return;
      drawer.dataset.open = 'false';
      if (overlay) {
        overlay.dataset.open = 'false';
        setTimeout(() => { overlay.hidden = true; }, 350);
      }
      if (openBtn) openBtn.setAttribute('aria-expanded', 'false');
      document.removeEventListener('keydown', onKey);
      if (lastFocused instanceof HTMLElement) lastFocused.focus();
    }
    function onKey(e) {
      if (e.key === 'Escape') return closeDrawer();
      if (e.key === 'Tab') trapFocus(e);
    }
    function trapFocus(e) {
      if (!drawer) return;
      const focusables = drawer.querySelectorAll(
        'a[href], button:not([disabled]), summary, input:not([disabled]), select:not([disabled]), [tabindex]:not([tabindex="-1"])'
      );
      if (!focusables.length) return;
      const first = focusables[0];
      const last = focusables[focusables.length - 1];
      if (e.shiftKey && document.activeElement === first) {
        last.focus();
        e.preventDefault();
      } else if (!e.shiftKey && document.activeElement === last) {
        first.focus();
        e.preventDefault();
      }
    }

    if (openBtn) openBtn.addEventListener('click', openDrawer);
    if (closeBtn) closeBtn.addEventListener('click', closeDrawer);
    if (overlay) overlay.addEventListener('click', closeDrawer);

    /* Filter form: auto-submit on desktop */
    const form = root.querySelector('[data-collection-filters]');
    if (form) {
      const isDesktop = () => window.matchMedia('(min-width: 960px)').matches;
      form.addEventListener('change', (e) => {
        const t = e.target;
        if (t && t.matches && t.matches('input[type="number"]')) return;
        if (isDesktop()) form.requestSubmit ? form.requestSubmit() : form.submit();
      });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mobile-nav-drawer"]) return;
  try {
    
  (() => {
    const drawer = document.getElementById('nav-drawer');
    const overlay = document.getElementById('nav-overlay');
    if (!drawer || !overlay) return;
    let lastFocused = null;

    function open() {
      lastFocused = document.activeElement;
      drawer.hidden = false; overlay.hidden = false;
      requestAnimationFrame(() => {
        drawer.dataset.open = 'true';
        overlay.dataset.open = 'true';
      });
      const first = drawer.querySelector('[data-nav-close]');
      if (first) first.focus();
      document.addEventListener('keydown', onKey);
      document.dispatchEvent(new CustomEvent('nav:opened'));
    }
    function close() {
      drawer.dataset.open = 'false';
      overlay.dataset.open = 'false';
      setTimeout(() => { drawer.hidden = true; overlay.hidden = true; }, 350);
      document.removeEventListener('keydown', onKey);
      if (lastFocused instanceof HTMLElement) lastFocused.focus();
      document.dispatchEvent(new CustomEvent('nav:closed'));
    }
    function onKey(e) {
      if (e.key === 'Escape') close();
      if (e.key === 'Tab') trapFocus(e);
    }
    function trapFocus(e) {
      const focusables = drawer.querySelectorAll(
        'a[href], button:not([disabled]), summary, input:not([disabled]), [tabindex]:not([tabindex="-1"])'
      );
      if (!focusables.length) return;
      const first = focusables[0];
      const last = focusables[focusables.length - 1];
      if (e.shiftKey && document.activeElement === first) { last.focus(); e.preventDefault(); }
      else if (!e.shiftKey && document.activeElement === last) { first.focus(); e.preventDefault(); }
    }

    window.MMNavDrawer = { open, close };
    overlay.addEventListener('click', close);
    drawer.querySelector('[data-nav-close]').addEventListener('click', close);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["price-match-form"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const inputs = document.querySelectorAll('[data-pm-file-input]');
    inputs.forEach(function (input) {
      input.addEventListener('change', function () {
        const wrap = input.closest('.price-match-form__file');
        if (!wrap) return;
        const label = wrap.querySelector('[data-pm-file-name]');
        if (!label) return;
        if (input.files && input.files.length > 0) {
          label.textContent = input.files[0].name;
        } else {
          label.textContent = 'No file chosen';
        }
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-detail"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const root = document.querySelector('[data-product-section]');
    if (!root) return;

    /* ─── Add to cart: AJAX submit → open cart drawer ─────────────── */
    const productForm = root.querySelector('form[action$="/cart/add"]');
    if (productForm) {
      productForm.addEventListener('submit', async (e) => {
        if (e.submitter && !e.submitter.matches('[data-add-to-cart]')) return;

        e.preventDefault();
        const submit = productForm.querySelector('[data-add-to-cart]');
        const label = submit && submit.querySelector('.buy-buttons__label');
        const originalLabel = label && label.textContent;

        if (submit) submit.disabled = true;
        if (label) label.textContent = 'Adding…';

        try {
          const formData = new FormData(productForm);
          const res = await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Accept': 'application/json' },
            body: formData
          });
          if (!res.ok) {
            const err = await res.json().catch(() => ({}));
            throw new Error(err.description || err.message || 'Add to cart failed');
          }

          if (window.MMCart && typeof window.MMCart.render === 'function') {
            await window.MMCart.render();
            if (typeof window.MMCart.open === 'function') window.MMCart.open();
          }

          try {
            const cartRes = await fetch('/cart.js', { headers: { 'Accept': 'application/json' } });
            if (cartRes.ok) {
              const cart = await cartRes.json();
              document.querySelectorAll('[data-cart-count]').forEach(el => { el.textContent = cart.item_count; });
              document.dispatchEvent(new CustomEvent('cart:updated', { detail: cart }));
            }
          } catch (_) { /* ignore */ }

          if (label) label.textContent = 'Added ✓';
          setTimeout(() => {
            if (submit) submit.disabled = false;
            if (label && originalLabel) label.textContent = originalLabel;
          }, 1500);
        } catch (err) {
          if (label) label.textContent = 'Try again';
          if (submit) submit.disabled = false;
          setTimeout(() => {
            if (label && originalLabel) label.textContent = originalLabel;
          }, 2000);
          console.error('[product-form]', err);
        }
      });
    }

    /* ─── Quantity stepper ─────────────────────────────────────────── */
    const decBtn = root.querySelector('[data-qty-decrement]');
    const incBtn = root.querySelector('[data-qty-increment]');
    const qtyInput = root.querySelector('input[name="quantity"]');

    if (decBtn && incBtn && qtyInput) {
      decBtn.addEventListener('click', () => {
        const v = Math.max(1, Number(qtyInput.value || 1) - 1);
        qtyInput.value = v;
        qtyInput.dispatchEvent(new Event('change', { bubbles: true }));
      });
      incBtn.addEventListener('click', () => {
        const v = Math.max(1, Number(qtyInput.value || 1) + 1);
        qtyInput.value = v;
        qtyInput.dispatchEvent(new Event('change', { bubbles: true }));
      });
    }

    /* ─── Variant change → update price + URL + availability + SKU ── */
    function formatMoney(cents) {
      try {
        return new Intl.NumberFormat(document.documentElement.lang || 'en-US', {
          style: 'currency',
          currency: window.Shopify && window.Shopify.currency
            ? window.Shopify.currency.active
            : 'USD'
        }).format(cents / 100);
      } catch (_) {
        return '$' + (cents / 100).toFixed(2);
      }
    }

    root.addEventListener('variant:change', (e) => {
      const v = e.detail && e.detail.variant;
      if (!v) return;

      const url = new URL(window.location.href);
      url.searchParams.set('variant', v.id);
      window.history.replaceState({}, '', url.toString());

      const submit = root.querySelector('[data-add-to-cart]');
      if (submit) {
        submit.disabled = !v.available;
        const label = submit.querySelector('.buy-buttons__label');
        if (label) {
          label.textContent = v.available ? 'Add to cart' : 'Sold out';
        }
      }

      const stock = root.querySelector('[data-product-stock]');
      if (stock) {
        // Quantity comes from the map the block renders, NOT from `v`:
        // Shopify's variant JSON has no `inventory_quantity` field at all, so
        // `v.inventory_quantity` is undefined and `undefined <= 0` is false —
        // which made every variant read "In Stock" after a change while the
        // server-rendered state was correct.
        //
        // Map value is the tracked quantity, or null when inventory is not
        // tracked for that variant. A variant missing from the map (past
        // Liquid's 50-iteration for-loop cap) also falls through to in-stock.
        //
        // `available` is deliberately not consulted: it is true at zero
        // quantity because every variant uses inventoryPolicy CONTINUE. That is
        // also why ordering stays permitted — the button gates on `available`.
        let stockMap = {};
        try { stockMap = JSON.parse(stock.dataset.variantStock || '{}'); } catch (e) {}
        const qty = stockMap[v.id];
        const outOfStock = qty !== null && qty !== undefined && qty <= 0;
        const label = stock.querySelector('[data-stock-label]');
        stock.classList.toggle('product-section__stock--out', outOfStock);
        // Inline colours are cleared so the class above governs; they were set
        // by earlier runs of this handler.
        stock.style.color = '';
        const dot = stock.querySelector('.product-section__stock-dot');
        if (dot) dot.style.background = '';
        // Strings come off data attributes: Liquid is not rendered inside a
        // `{% javascript %}` block, so `| t` cannot be called from here.
        if (label) {
          label.textContent = outOfStock
            ? (stock.dataset.labelOut || 'Out of Stock - Buy Now')
            : (stock.dataset.labelInStock || 'In Stock — Ships Today');
        }
      }

      const priceEl = root.querySelector('[data-product-price]');
      if (priceEl) {
        const onSale = v.compare_at_price && v.compare_at_price > v.price;
        let was = priceEl.querySelector('.product-section__price-was');
        const current = priceEl.querySelector('.product-section__price-current');
        if (current) {
          current.textContent = formatMoney(v.price);
          current.classList.toggle('product-section__price-current--sale', !!onSale);
        }
        if (onSale) {
          if (!was) {
            was = document.createElement('s');
            was.className = 'product-section__price-was';
            priceEl.insertBefore(was, current);
          }
          was.textContent = formatMoney(v.compare_at_price);
        } else if (was) {
          was.remove();
        }
      }

      const skuEl = root.querySelector('.product-section__sku span');
      if (skuEl) skuEl.textContent = v.sku || '';
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-tabs"] && !Shopify.designMode) return;
  try {
    
  class ProductTabs extends HTMLElement {
    connectedCallback() {
      this.tabs = Array.from(this.querySelectorAll('.product-tabs__tab[data-tab-target]'));
      this.accordions = Array.from(this.querySelectorAll('.product-tabs__accordion[data-tab-target]'));
      this.panels = Array.from(this.querySelectorAll('[data-tab-panel]'));

      const triggers = this.tabs.concat(this.accordions);
      triggers.forEach((trigger) => {
        trigger.addEventListener('click', () => this.activate(trigger.dataset.tabTarget));
        trigger.addEventListener('keydown', (e) => {
          // Arrow key navigation only across the desktop tab list — accordion
          // buttons use vertical Tab navigation natively.
          if (!trigger.classList.contains('product-tabs__tab')) return;
          const idx = this.tabs.indexOf(trigger);
          if (e.key === 'ArrowRight') {
            e.preventDefault();
            const next = this.tabs[idx + 1] || this.tabs[0];
            next.focus();
            this.activate(next.dataset.tabTarget);
          } else if (e.key === 'ArrowLeft') {
            e.preventDefault();
            const prev = this.tabs[idx - 1] || this.tabs[this.tabs.length - 1];
            prev.focus();
            this.activate(prev.dataset.tabTarget);
          }
        });
      });
    }

    activate(target) {
      this.tabs.forEach((t) => {
        const on = t.dataset.tabTarget === target;
        t.classList.toggle('product-tabs__tab--active', on);
        t.setAttribute('aria-selected', on ? 'true' : 'false');
      });
      this.accordions.forEach((a) => {
        const on = a.dataset.tabTarget === target;
        a.classList.toggle('product-tabs__accordion--active', on);
        a.setAttribute('aria-expanded', on ? 'true' : 'false');
      });
      this.panels.forEach((p) => {
        const on = p.dataset.tabPanel === target;
        p.hidden = !on;
        p.classList.toggle('product-tabs__panel--active', on);
      });
    }
  }
  if (!customElements.get('product-tabs')) customElements.define('product-tabs', ProductTabs);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-products"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const placeholder = document.querySelector('[data-related-products-url]');
    if (!placeholder) return;

    const url = placeholder.dataset.relatedProductsUrl;
    if (!url) return;

    fetch(url)
      .then((r) => r.text())
      .then((html) => {
        // Parse trusted same-origin Shopify Section Rendering API response via DOMParser
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const replacement =
          doc.querySelector('[data-related-products]') ||
          doc.querySelector('.related-products');
        if (replacement) {
          placeholder.replaceWith(replacement);
        }
      })
      .catch(() => {
        // Silent failure — placeholder stays empty.
      });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["videos-grid"] && !Shopify.designMode) return;
  try {
    
  (() => {
    /* YouTube poster fallback: maxresdefault doesn't exist for every video,
       so swap to the always-available hqdefault if it 404s. */
    document.querySelectorAll('[data-yt-thumb]').forEach((img) => {
      img.addEventListener('error', function onErr() {
        img.removeEventListener('error', onErr);
        img.src = 'https://img.youtube.com/vi/' + img.dataset.ytThumb + '/hqdefault.jpg';
      });
    });

    /* Click the poster → swap in an autoplaying YouTube iframe in place. */
    document.querySelectorAll('[data-video-play]').forEach((btn) => {
      btn.addEventListener('click', () => {
        const media = btn.closest('[data-video-media]');
        if (!media || media.hasAttribute('data-playing')) return;
        const id = media.dataset.ytId;
        if (!id) return;

        const iframe = document.createElement('iframe');
        iframe.className = 'video-card__embed';
        iframe.src =
          'https://www.youtube.com/embed/' + id + '?autoplay=1&rel=0&modestbranding=1';
        iframe.title = media.dataset.videoTitle || 'Video';
        iframe.allow =
          'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share';
        iframe.setAttribute('allowfullscreen', '');

        media.replaceChildren(iframe);
        media.setAttribute('data-playing', '');
      });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
